export default "__VITE_ASSET__CLuM$oQV__"